import { Dialog, DialogContent, Box, Typography, DialogActions, TextField, Button, Autocomplete, InputAdornment, MenuItem, Alert } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setInvoiceDetailsData } from '../../../redux/invoiceDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/invoices/editInvoiceLine.css';

export const EditInvoiceLine = ({ editLine, setEditLine }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState('');
    const invoiceDetailsData = useSelector((state) => state.InvoiceDetailsData);
    const line = invoiceDetailsData?.invoice_detail?.find(
        (detail) => detail.id === editLine.line_id
    );

    const formik = useFormik({
        initialValues: {
            description: line.description,
            amount: line.amount,
            machine_ids: line.invoice_detail_machine.length > 1 ? null : { value: line.invoice_detail_machine[0].machine.id, label: line.invoice_detail_machine[0].machine.name },
            order: line.order,
        },
        validationSchema: Yup.object().shape({
            description: Yup.string().required(t('isRequired')),
            amount: Yup.number().required(t('isRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const lineData = {
                    description: values.description,
                    amount: values.amount,
                    invoice_id: id,
                    order: values.order,
                    machine_ids: values.machine_ids ? [values.machine_ids.value] : invoiceDetailsData.invoice_machine.map((machine) => machine.machine.id),
                }
                const response = await axios.patch(`invoice-detail/${editLine.line_id}`, lineData)

                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier ligne du facture' }));
                    dispatch(setInvoiceDetailsData({
                        ...invoiceDetailsData,
                        invoice_detail: invoiceDetailsData.invoice_detail.map((detail) =>
                            detail.id === editLine.line_id ? { ...detail, ...response.data } : detail
                        ),
                    }));
                    setEditLine({ line_id: null, open: false });
                }
            } catch (error) {
                console.error('Error updating machine line:', error);
                CustomErrorLogger(error, 'Error updating machine line');
                setErrMsg(error?.response?.data?.message || error.message || 'erreur lors de la modification de la ligne du facture');
            }
        },
    });

    const { handleSubmit, values, handleBlur, touched, errors, handleChange } = formik;

    return (
        <Dialog open={editLine.open} fullWidth maxWidth='md'>
            <Box onClick={() => setEditLine({ line_id: null, open: false })} className='editInvoiceLine_icon_text'>
                <Typography className='editInvoiceLine_title'>Modifier ligne du facture</Typography>
                <Iconify icon={"material-symbols:close"} className='editInvoiceLine_close_icon' />
            </Box>
            {errMsg && <Alert severity="error">{errMsg}</Alert>}
            <form onSubmit={handleSubmit}>
                <DialogContent className='editInvoiceLine_dialog_content'>

                    <Box id="outlined-weight-helper-text" className="editInvoiceLine_hint">
                        <Iconify className='editInvoiceLine_info_icon' icon={"material-symbols:info-outline"} />
                        Les montant sons TTC (Toutes Taxes Comprises)
                    </Box>
                    {invoiceDetailsData?.invoice_machine.length === 0 &&
                        <Typography className='errMsg'>Cette facture ne concerne aucune machine !</Typography>
                    }
                    <Box className='editInvoiceLineline_box'>
                        <TextField
                            fullWidth
                            placeholder='Déscription'
                            value={values.description}
                            className='editInvoiceLineInputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name='description'
                            error={touched.description && Boolean(errors.description)}
                            helperText={touched.description && errors.description}
                            aria-describedby="outlined-weight-helper-text"
                        />
                        <TextField
                            fullWidth
                            type='number'
                            placeholder='Montant'
                            value={values.amount}
                            className='editInvoiceLineInputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name='amount'
                            error={touched.amount && Boolean(errors.amount)}
                            helperText={touched.amount && errors.amount}
                            aria-describedby="outlined-weight-helper-text"
                            InputProps={{
                                endAdornment: <InputAdornment position="end" className='editInvoiceLineInputAdornment'><div>€</div></InputAdornment>
                            }}
                            sx={{
                                '& .MuiInputBase-root': {
                                    paddingRight: '0px !important',
                                },
                            }}
                        />
                        <Autocomplete
                            fullWidth
                            options={invoiceDetailsData?.invoice_machine.map((machine) => ({ value: machine.machine.id, label: machine.machine.name }))}
                            value={values.machine_ids}
                            onChange={(event, newValue) => {
                                formik.setFieldValue('machine_ids', newValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder='Tous les machines'
                                    variant="outlined"
                                    className='editInvoiceLineInputField'
                                />
                            )}
                            renderOption={(props, option, { selected }) => (
                                <MenuItem
                                    {...props}
                                    selected={selected}
                                    className='MachineFiltration_select_metier_item'
                                >
                                    {option.label}
                                </MenuItem>
                            )}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            noOptionsText='Aucune option'
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='editInvoiceLine_dialog_actions'>
                    <Button className='editInvoiceLine_button_annuler' onClick={() => setEditLine({ line_id: null, open: false })}>{t('Annuler')}</Button>
                    <Button className='editInvoiceLine_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};